import React from "react";
import { Switch, Redirect } from "react-router-dom";

import Route from "../Auth/ProtectedRoute";

import Home from "../common/Home";
import FinancialReport from "./FinancialReport";
import FinancialReportForm from "./FinancialReport/FinancialReportForm";
import AnalysisReport from "./AnalysisReport";
import ChapterBudget from "./ChapterBudget";
import MemberCounts from "./MemberCounts";
import ChapterBudgetForm from "./ChapterBudget/ChapterBudgetForm";
import FinancialReportMailLogView from "./FinancialReport/FinancialReportMailLogView";

const ChapterDashboard = () => {
  return (
    <Switch>
      <Route path="/chapter/home" component={Home} />
      <Route
        exact
        path="/chapter/financial-report"
        component={FinancialReport}
      />
      <Route
        exact
        path="/chapter/financial-report/:id"
        component={FinancialReportForm}
      />
      <Route
        exact
        path="/chapter/financial-report/:id/mail-log"
        component={FinancialReportMailLogView}
      />
      <Route path="/chapter/analysis-report" component={AnalysisReport} />
      <Route exact path="/chapter/budget" component={ChapterBudget} />
      <Route exact path="/chapter/budget/:id" component={ChapterBudgetForm} />
      <Route path="/chapter/member-count" component={MemberCounts} />
      <Redirect exact from="/chapter" to="/chapter/home" />
    </Switch>
  );
};

export default ChapterDashboard;
